import { Action, getModule, Module, VuexModule } from "vuex-module-decorators";
import store from "@/store";
import { container } from "tsyringe";
import {
  DutyTaxConfigurationListFilter,
  DutyTaxConfigurationListResult,
  DutyTaxResolveParams,
  DutyTaxResolveResult
} from "@/domain/entities/DutyTaxConfiguration";
import { DutyTaxConfigurationPresenter } from "@/app/ui/presenters/DutyTaxConfigurationPresenter";

@Module({
  namespaced: true,
  dynamic: true,
  store,
  name: "duty-tax-configuration"
})
class DutyTaxConfigurationStore extends VuexModule {
  @Action
  public getDutyTaxConfigurationList(
    params: DutyTaxConfigurationListFilter
  ): Promise<DutyTaxConfigurationListResult> {
    const presenter = container.resolve(DutyTaxConfigurationPresenter);
    return presenter.getList(params);
  }

  @Action
  public resolveDutyTaxConfiguration(
    params: DutyTaxResolveParams
  ): Promise<DutyTaxResolveResult | null> {
    const presenter = container.resolve(DutyTaxConfigurationPresenter);
    return presenter.resolve(params);
  }
}

export const DutyTaxConfigurationController = getModule(
  DutyTaxConfigurationStore
);
